import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fw-bold text-gray-600" }
const _hoisted_6 = {
  key: 0,
  style: {"white-space":"nowrap"}
}
const _hoisted_7 = { class: "odd" }
const _hoisted_8 = {
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_9 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "\n          col-sm-12 col-md-5\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-start\n        " }
const _hoisted_14 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "\n          col-sm-12 col-md-7\n          d-flex\n          align-items-center\n          justify-content-center justify-content-md-end\n        " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "\n          table\n          align-middle\n          table-row-dashed\n          fs-6\n          gy-5\n          dataTable\n          no-footer\n        "]),
        id: "kt_customers_table",
        role: "grid"
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (_ctx.selectedType.includes(cell.key))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                      class: _normalizeClass([[
                  cell.name && 'p-3 min-w-125px text-capitalize fw-bolder fs-6',
                  cell.sortable !== false && 'sorting',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ], "text-dark bg-secondary"]),
                      tabindex: "0",
                      rowspan: "1",
                      colspan: "1",
                      style: {"cursor":"pointer"}
                    }, _toDisplayString(cell.name), 11, _hoisted_4))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "odd"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (_ctx.selectedType.includes(cell.key))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                            _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                              _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.emptyTableText), 1)
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", null, [
                _createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_19, 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination.page = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}